const defaultSteps = [
  {
    name: 'Participant Information',
  },
  {
    name: 'Review & Pay',
  },
  {
    name: 'Waiver',
  },
]

const composeSteps = ({ paymentRequired, shouldShowWaiver }) => {
  let steps = defaultSteps
  if (!paymentRequired) {
    steps = steps.filter(step => step.name !== 'Review & Pay')
  }
  if (!shouldShowWaiver) {
    steps = steps.filter(step => step.name !== 'Waiver')
  }
  return steps
}

export { composeSteps }
